import { getInitialVisitSubstitutionPartsListQueryFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getSubstitutionPartsList/getInitialVisitSubstitutionPartsListQueryFunction';
import {
  SubstitutionPartsListParams,
  SubstitutionPartsListResponse,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/getSubstitutionPartsList/getSubstitutionPartsListQuery.type';
import { substitutionPartsListQueryFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getSubstitutionPartsList/getSubstitutionPartsListQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const getSubstitutionPartsListQueryOptions = (
  params: SubstitutionPartsListParams,
) => {
  const queryFn = () => {
    if (params?.type && params?.type === 'initial') {
      return getInitialVisitSubstitutionPartsListQueryFunction(params);
    }
    return substitutionPartsListQueryFunction(params);
  };
  return queryOptions({
    queryKey: ['get_substitution_parts_list', params],
    queryFn: () => queryFn(),
    select: (data: SubstitutionPartsListResponse) => {
      return {
        count: data?.count,
        total_price: data?.total_price,
        substitution: data?.substitution?.map((item) => ({ ...item })),
        id: data?.substitution?.map((item) => ({ id: item?.id })),
        cartData: data?.substitution?.map((item) => [
          { name: 'نام قطعه :', value: item?.part_name },
          {
            name: 'قیمت :',
            value: `${new Intl.NumberFormat('fa-IR').format(+item?.part_price)} ریال`,
          },
          {
            name: 'ارزش داغی :',
            value: `${new Intl.NumberFormat('fa-IR').format(+item?.daghi_price)} ریال`,
          },
          {
            name: 'اجرت تعمیرات :',
            value: `${new Intl.NumberFormat('fa-IR').format(+item?.wage_price)} ریال`,
          },
          { name: 'میزان تصادف :', value: item?.accident_level_fa },
        ]),
      };
    },
  });
};
